export default "__VITE_ASSET__kue7uTSL__"